<script>
	import { browser } from '$app/environment';
	import { variables } from '$lib/variables';
	import { onMount } from 'svelte';
	import { onDestroy } from 'svelte';
	let lightGallery, lgThumbnail, lgZoom;

	export let images;
	let gallery;
	let gallery2;
	$: innerWidth = 0;
	let lgallery = null;
	let lgallery2 = null;
	onMount(async () => {
		if (browser) {
			console.log(111,images);
			
			[lightGallery, lgThumbnail, lgZoom] = await Promise.all([
				import('lightgallery'),
				import('lightgallery/plugins/thumbnail'),
				import('lightgallery/plugins/zoom')
			]);
			lgallery = lightGallery.default(gallery, {
				plugins: [lgZoom.default, lgThumbnail.default],
				speed: 500
			});
			// Используйте setTimeout чтобы убедиться, что DOM полностью загружен и галерея инициализирована
			setTimeout(() => {
				const firstImage = gallery.querySelector('a'); // Находим первую ссылку в галерее
				if (firstImage) firstImage.click(); // Симулируем клик на первую ссылку
			}, 0);
			// Создание нового элемента стиля
			let styleElement = document.createElement('style');

			// Задание стилей
			styleElement.innerHTML = `
			.lg-backdrop {
				background-color: white !important;
			}
            .lg-thumb-outer{
				background-color: white !important;
			}

		`;

			// Добавление стиля в элемент head
			document.head.appendChild(styleElement);
		}
	});
	function CloseComponent() {
		alert(222);
	}
	onDestroy(() => {
		gallery = null;
		gallery2 = null;
		images = [];
		try {
			document.querySelector('.lg-container').remove();
		} catch (error) {}
	});

</script>

<svelte:window bind:innerWidth />

<div class="d-flex">
	<div bind:this={gallery}>
		{#each images as photo}
			<a data-sub-html="iloveitalianbags" href="{photo.image}">
				<img
					class="hidden"
					alt={photo.image}
					src="{photo.image_thumbnail}"
				/>
			</a>
		{/each}
	</div>
</div>

<style>
	.lg-backdrop {
		background-color: white !important;
	}
</style>
